query GetYouTubeChatSessions {
  sessions: StreamToolsGetYouTubeChatSessions {
    sessionId
    eventId
    scope
    status
    startedAt
    stoppedAt
    stopReason
    channelId
    channelTitle
    videoId
    channelProfileImageUrl
    foreignEvent
  }
}
